import { app } from '../../../../app';

class AccountConfigService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    get(applicationId, accountId) {
        return this.$http
            .get(`app/rest/accountConfig/${applicationId}/${accountId}`)
            .then((response) => response.data);
    }

    save(applicationId, accountId, config) {
        return this.$http
            .post(`app/rest/accountConfig/${applicationId}/${accountId}`, config)
            .then((response) => response.data);
    }
}

app.service('AccountConfigService', AccountConfigService);



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/account-config/account-config.service.js